import { render } from "./Calendar.vue?vue&type=template&id=32f40568"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/Calendar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "32f40568"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('32f40568', __exports__)) {
    api.reload('32f40568', __exports__)
  }
  
  module.hot.accept("./Calendar.vue?vue&type=template&id=32f40568", () => {
    api.rerender('32f40568', render)
  })

}


export default __exports__